import { formatPostcode } from '../functions/cart_drawer_utils.js';
import { initCartDrawerActions } from '../functions/cart_drawer_actions.js';

export function initCartDrawer() {
    (function($) {

    'use strict';

    const cartDrawerEnabled = document.body.getAttribute('data-cart-drawer-enabled') === '1';

    if (!cartDrawerEnabled) {
        return;
    }

    // Elementos do header dos temas que abrem o carrinho (passam a abrir o drawer)
    const OPEN_SELECTORS = '[data-cart-drawer-open], [data-drawer-open][data-target="cart-content"], #cart > button, #cart_mobile > button, .cart-toggle, .menu_mobile_fixed_list_link.cart, a.open_cart[data-rd-navbar-toggle], .page-header-cart__button';
    const ADDING_TEXT = 'Adicionando...';
    const CONTENT_TTL = 4000;
    // Contrato do markup padrão do carrinho drawer nos templates starter.
    const CART_DRAWER_SELECTOR = '#cart > #cart-content.drawer';

    let last_add_at = 0;
    let content_at = 0;
    let loading_now = false;
    let last_quantity = null;
    let request_seq = 0;
    let suggest_seq = 0;
    const qty_errors = {};

    function getDrawer() {
        return $(CART_DRAWER_SELECTOR).first();
    }

    if (!getDrawer().length) {
        console.error('O drawer nativo esperado não foi encontrado:', CART_DRAWER_SELECTOR);
        return;
    }

    window.cartDrawerActive = true;

    function isOpen() {
        return getDrawer().is('[open]');
    }

    function setLoading(loading) {
        const $drawer = getDrawer();

        $drawer.toggleClass('is-loading', loading);
        $drawer.attr('aria-busy', loading ? 'true' : 'false');
    }

    function open() {
        if (window.IrrobaDrawer && typeof window.IrrobaDrawer.open === 'function') {
            window.IrrobaDrawer.open('cart-content');
        } else {
            getDrawer().attr('open', '');
            $('body').addClass('drawer_is_opened');
        }

        $('body').addClass('cart-drawer-open');

        loadSuggestions();
    }

    function close() {
        if (window.IrrobaDrawer && typeof window.IrrobaDrawer.close === 'function') {
            window.IrrobaDrawer.close('cart-content');
        } else {
            getDrawer().removeAttr('open');
            if (!$('.drawer[open]').length) {
                $('body').removeClass('drawer_is_opened cart-drawer-open');
            }
        }
    }

    function applyQuantity(quantity) {
        $('#cart-quantity, .js-cart_quantity').html(quantity);
        $('.menu_mobile_fixed_count_products').html(quantity);

        $('body').toggleClass('cart-not-empty', quantity > 0).toggleClass('cart-empty', quantity === 0);
    }

    function setQuantity(quantity) {
        last_quantity = parseInt(quantity, 10) || 0;

        applyQuantity(last_quantity);
    }

    // Texto do botão de comprar enquanto o item é adicionado (vem do idioma da loja quando o drawer já foi carregado)
    function setAddingText(text) {
        $('#button-cart, .button-cart, .button_cart_v2').attr('data-loading-text', text).data('loadingText', text);
    }

    // Insere o drawer no body ou, se já existir, troca só o conteúdo (o painel não pisca)
    function render(html) {
        const $new = $($.parseHTML($.trim(html)));
        const $drawer = getDrawer();
        const $new_drawer = $new.filter('#cart-drawer').first();
        const $new_content = $new.find('.drawer__content').first();
        const $content = $drawer.find('.drawer__content').first();

        if (!$new_drawer.length || !$new_content.length || !$content.length) {
            console.error('Não foi possível atualizar o conteúdo do drawer nativo.');

            return;
        }

        $content.empty().append($new_content.contents()).addClass('cart-drawer__body');
        $drawer.attr('role', $new_drawer.attr('role'));
        $drawer.attr('aria-modal', $new_drawer.attr('aria-modal'));
        $drawer.attr('aria-label', $new_drawer.attr('aria-label'));
        $drawer.attr('data-text-adding', $new_drawer.attr('data-text-adding'));

        content_at = Date.now();

        const quantity = getDrawer().find('.cart-drawer-meta').data('quantity');

        setQuantity(quantity === undefined ? 0 : quantity);
        setAddingText(getDrawer().attr('data-text-adding') || ADDING_TEXT);
        setLoading(false);
        applyQtyErrors();
        applyGiftProgress();
        loadSuggestions();
    }

    // Termômetro de brinde: o carrinho normal preenche a barra com um script inline, que não roda quando o HTML
    // entra no drawer; o preenchimento é aplicado aqui a partir do data-done
    function applyGiftProgress() {
        getDrawer().find('.gift_percent_progress .progress-done').each(function() {
            const percent = parseFloat($(this).attr('data-done')) || 0;

            $(this).css({ width: 'calc((100% - 28px) * ' + (percent / 100) + ')', opacity: 1 });

            if (percent >= 100) {
                $(this).siblings('.svg_background').addClass('active');
                $(this).closest('.gift_progress').addClass('active');
            }
        });
    }

    // Sugestões: buscadas depois que o drawer já abriu; o esqueleto fica no lugar até chegarem
    function loadSuggestions() {
        const $lazy = getDrawer().find('[data-cart-drawer-suggest-lazy]');

        // Só busca com o drawer aberto (o pré-carregamento do conteúdo não dispara a busca) e uma vez por desenho
        if (!$lazy.length || !isOpen() || $lazy.attr('data-requested')) {
            return;
        }

        $lazy.attr('data-requested', '1');

        const seq = ++suggest_seq;

        $.get('index.php?route=common/cart_drawer_suggestions/html&v=' + Date.now(), function(html) {
            const $placeholder = getDrawer().find('[data-cart-drawer-suggest-lazy]');

            // Resposta velha (o drawer foi redesenhado nesse meio tempo) ou espaço já removido
            if (seq !== suggest_seq || !$placeholder.length) {
                return;
            }

            if ($.trim(html) === '') {
                $placeholder.remove();
                return;
            }

            $placeholder.replaceWith(html);
        }).fail(function() {
            getDrawer().find('[data-cart-drawer-suggest-lazy]').remove();
        });
    }

    // Ícone de aviso ao lado da quantidade (ex.: "quantidade em estoque insuficiente") com a mensagem em tooltip
    function applyQtyErrors() {
        getDrawer().find('.cart-drawer-qty').each(function() {
            const message = qty_errors[$(this).attr('data-key')];
            const $wrap = $(this).closest('.cart-drawer-item__qty-wrap');

            $wrap.find('.cart-drawer-qty__alert').remove();

            if (message) {
                $('<button type="button" class="cart-drawer-qty__alert"></button>').attr('aria-label', message).appendTo($wrap);
            }
        });
    }

    function showTooltip($icon) {
        const $panel = getDrawer().find('.cart-drawer__panel, section').first();
        let $tip = $panel.find('.cart-drawer-tooltip');

        if (!$tip.length) {
            $tip = $('<div class="cart-drawer-tooltip" role="tooltip"></div>').appendTo($panel);
        }

        $tip.text($icon.attr('aria-label')).css({ display: 'block', visibility: 'hidden', top: 0, left: 0 });

        const panel = $panel[0].getBoundingClientRect();
        const icon = $icon[0].getBoundingClientRect();
        const width = $tip.outerWidth();
        const height = $tip.outerHeight();

        // Prefere acima do ícone; se não couber, abre abaixo. Alinha à direita e não sai do painel.
        let top = icon.top - panel.top - height - 8;

        if (top < 56) {
            top = icon.bottom - panel.top + 8;
        }

        const left = Math.max(8, Math.min(icon.right - panel.left - width, panel.width - width - 8));

        $tip.css({ top: top, left: left, visibility: 'visible' });
    }

    function hideTooltip() {
        getDrawer().find('.cart-drawer-tooltip').css('display', 'none');
    }

    $(document).on('mouseenter focusin', '.cart-drawer-qty__alert', function() {
        showTooltip($(this));
    });

    $(document).on('mouseleave focusout', '.cart-drawer-qty__alert', hideTooltip);

    $(document).on('scroll', '.cart-drawer__items', hideTooltip);

    // Busca o conteúdo atualizado. Respostas mais antigas que o add (ou que outra busca) são descartadas.
    function load(callback) {
        const seq = ++request_seq;
        const sent_at = Date.now();

        loading_now = true;
        setLoading(true);

        $.get('index.php?route=common/cart_drawer&v=' + sent_at, function(html) {
            if (seq !== request_seq || sent_at < last_add_at) {
                return;
            }

            render(html);

            if (callback) {
                callback();
            }
        }).fail(function() {
            setLoading(false);
        }).always(function() {
            if (seq === request_seq) {
                loading_now = false;
            }
        });
    }

    // Chamado pelo product.tpl com a resposta do add: abre o drawer já preenchido
    window.openCartDrawerAfterAdd = function(json) {
        $('#modal-cart, .modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if (json.cart_drawer_html) {
            last_add_at = Date.now();
            request_seq++;

            render(json.cart_drawer_html);
            open();

            return true;
        }

        open();
        load(open);

        return true;
    };

    // Cliques no carrinho do header abrem o drawer na hora; o conteúdo carrega depois (ou já veio do pré-carregamento)
    document.addEventListener('click', function(event) {
        if (!event.target.closest(OPEN_SELECTORS)) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        open();

        const fresh = Date.now() - content_at < CONTENT_TTL;

        if (!loading_now && !fresh) {
            load();
        }
    }, true);

    // Ao chegar no ícone do carrinho (mouse, toque ou teclado) o conteúdo já começa a carregar
    function prefetch(event) {
        if (!event.target.closest || !event.target.closest(OPEN_SELECTORS)) {
            return;
        }

        const fresh = Date.now() - content_at < CONTENT_TTL;

        if (!loading_now && !fresh) {
            load();
        }
    }

    ['pointerover', 'touchstart', 'focusin'].forEach(function(name) {
        document.addEventListener(name, prefetch, { capture: true, passive: true });
    });

    function showFeedback(message) {
        const $alert = $('<div class="cart-drawer-alert cart-drawer-alert--danger" role="alert"></div>').text(message || '');

        getDrawer().find('.cart-drawer__alerts').prepend($alert);
    }

    function closeRegions() {
        getDrawer().find('.cart-drawer-sheet').remove();
    }

    // Regiões de frete grátis: painel dentro do drawer (um modal do tema ficaria atrás dele)
    function openRegions(meta) {
        closeRegions();

        $.ajax({
            url: 'index.php?route=checkout/cart/getFreeShippingRegions',
            type: 'post',
            dataType: 'json',
            success: function(json) {
                const $sheet = $('<div class="cart-drawer-sheet" role="dialog"></div>');
                const $head = $('<div class="cart-drawer-sheet__head"></div>');
                const $body = $('<div class="cart-drawer-sheet__body"></div>');

                $head.append($('<span class="cart-drawer-sheet__title"></span>').text(meta.regionsTitle || ''));
                $head.append($('<button type="button" class="cart-drawer__close" data-cart-drawer-sheet-close></button>').attr('aria-label', meta.regionsClose || '').html('&times;'));

                if (json.success && json.free_shipping && json.free_shipping.length) {
                    const $table = $('<table class="cart-drawer-sheet__table"><thead><tr></tr></thead><tbody></tbody></table>');

                    [meta.regionsRegion, meta.regionsCepStart, meta.regionsCepEnd, meta.regionsMinimum].forEach(function(label) {
                        $table.find('thead tr').append($('<th></th>').text(label || ''));
                    });

                    json.free_shipping.forEach(function(row) {
                        const $tr = $('<tr></tr>');

                        $tr.append($('<td></td>').text(row.region));
                        $tr.append($('<td></td>').text(formatPostcode(row.cep_start)));
                        $tr.append($('<td></td>').text(formatPostcode(row.cep_end)));
                        $tr.append($('<td class="is-strong"></td>').text(row.free_price));
                        $table.find('tbody').append($tr);
                    });

                    $body.append($table);
                } else {
                    $body.append($('<p class="cart-drawer-sheet__empty"></p>').text(meta.regionsAll || ''));
                }

                $sheet.append($head, $body);
                const $panel = getDrawer().find('.cart-drawer__panel, section').first();

                $panel.append($sheet);
            }
        });
    }

    // Os elementos "Ver mais regiões" e "Remover cupom" vêm do carrinho normal (com onclick/JS da página do carrinho)
    document.addEventListener('click', function(event) {
        const drawer = getDrawer().get(0);

        if (!drawer || !drawer.contains(event.target)) {
            return;
        }

        const regions = event.target.closest('.js-shippingFreeModal');
        const coupon = event.target.closest('.btn-remove-coupon');

        if (!regions && !coupon) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const meta = getDrawer().find('.cart-drawer-meta').data() || {};

        if (regions) {
            openRegions(meta);
            return;
        }

        setLoading(true);

        $.ajax({
            url: 'index.php?route=onestepcheckout/checkout/validateRemoveCoupon',
            type: 'post',
            dataType: 'json',
            success: function() {
                load();
            },
            error: function() {
                setLoading(false);
                showFeedback(meta.couponError);
            }
        });
    }, true);

    $(document).on('click', '[data-cart-drawer-sheet-close]', closeRegions);

    $(document).on('click', '[data-cart-drawer-close]', close);

    $(document).on('keydown', function(event) {
        if (event.key === 'Escape') {
            close();
        }
    });

    // Botão de comprar da listagem: mostra "Adicionando..." enquanto o item é adicionado (como no botão do produto)
    let listing_button = null;
    let listing_button_at = 0;

    document.addEventListener('click', function(event) {
        const button = event.target.closest('.product-btn');

        if (button) {
            listing_button = button;
            listing_button_at = Date.now();
        }
    }, true);

    // Botões em "Adicionando..." até a requisição terminar: o JS do tema/loja não consegue resetá-los antes
    let locked_buttons = [];
    let button_plugin = null;

    // Envolve $.fn.button (refeito a cada add, pois o tema pode redefini-lo): 'reset' ignora os botões travados
    function lockButtonPlugin() {
        const current = $.fn.button;

        if (!current || current.original) {
            return;
        }

        const wrapped = function(state) {
            const free = state === 'reset' ? this.filter(function() {
                return locked_buttons.indexOf(this) === -1;
            }) : this;

            return free.length ? current.call(free, state) : this;
        };

        // 'original' também serve de marca: já envolvido, não envolve de novo
        wrapped.original = current;
        button_plugin = current;
        $.fn.button = wrapped;
    }

    // Botão com data-loading-text: o plugin do tema cuida do texto. Sem ele (listagem): guarda o HTML e troca o texto
    function startLoading(button) {
        if (button_plugin && button.hasAttribute('data-loading-text')) {
            button_plugin.call($(button), 'loading');

            return;
        }

        button.setAttribute('data-cart-drawer-loading', button.innerHTML);
        button.style.minWidth = button.offsetWidth + 'px';
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.textContent = getDrawer().attr('data-text-adding') || ADDING_TEXT;
    }

    function stopLoading(button) {
        const original = button.getAttribute('data-cart-drawer-loading');

        if (original === null) {
            if (button_plugin && button.hasAttribute('data-loading-text')) {
                button_plugin.call($(button), 'reset');
            }

            return;
        }

        button.innerHTML = original;
        button.removeAttribute('data-cart-drawer-loading');
        button.style.minWidth = '';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
    }

    // Respostas atrasadas do contador do header (disparadas antes do add) não podem sobrescrever o valor novo
    $(document).ajaxSend(function(event, xhr, settings) {
        xhr.cart_sent_at = Date.now();

        const is_add = /route=checkout\/cart\/(add|addcart)\b/i.test(settings.url || '');
        const recent_click = listing_button && Date.now() - listing_button_at < 3000;

        if (!is_add || !recent_click) {
            return;
        }

        lockButtonPlugin();

        // Botão clicado + botão principal do produto
        const main_button = document.getElementById('button-cart');

        xhr.cart_buttons = main_button && main_button !== listing_button ? [listing_button, main_button] : [listing_button];
        locked_buttons = locked_buttons.concat(xhr.cart_buttons);
        xhr.cart_buttons.forEach(startLoading);
    });

    $(document).ajaxComplete(function(event, xhr) {
        if (!xhr.cart_buttons) {
            return;
        }

        locked_buttons = locked_buttons.filter(function(button) {
            return xhr.cart_buttons.indexOf(button) === -1;
        });

        xhr.cart_buttons.forEach(stopLoading);
    });

    $(document).ajaxSuccess(function(event, xhr, settings) {
        const stale = last_add_at > 0 && xhr.cart_sent_at < last_add_at;

        if (stale && last_quantity !== null && (settings.url || '').indexOf('countCartItens') > -1) {
            applyQuantity(last_quantity);
        }
    });

    $(function() {
        setAddingText(ADDING_TEXT);
    });

    initCartDrawerActions({
        getDrawer: getDrawer,
        setLoading: setLoading,
        load: load,
        qty_errors: qty_errors,
        openAfterAdd: function(json) {
            window.openCartDrawerAfterAdd(json);
        },
        drawerSelector: CART_DRAWER_SELECTOR
    });
})(jQuery);
}
